<template>
  <div class="moreChatPopover" v-show="isShow" ref="moreChatPopover">
    <div
      class="chatItem"
      v-for="(value, key) in list"
      :key="key"
      @click="clickChatItem(value)"
    >
      <img class="leftImg" :src="value.icon" alt="" />
      <div class="right">
        <div class="text">{{ value.name }}</div>
        <div class="vipTag" v-show="value.vipOnly == 1">会员专属</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["list", "isShow", "event"],
  methods: {
    // 点击chatItem
    clickChatItem: function (value) {
      this.$emit("clickChatItem", value);
    },
  },
  watch: {
    event: function (newVal) {
      if (newVal) {
        // 等待渲染管线 处理完v-show
        this.$nextTick(() => {
          const popoverEl = this.$refs["moreChatPopover"];
          const popoverRect =
            this.$refs["moreChatPopover"].getBoundingClientRect();
          const spacing = 0;

          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;

          let top = 0;
          let left = 0;
          let placement = "right";
          
          // 判断是否存在currentTarget (iOS兼容)
          if (this.event.currentTarget) {
            // 原有逻辑：使用触发元素的位置
            const triggerEl = this.event.currentTarget;
            const triggerRect = triggerEl.getBoundingClientRect();
            
            // 先尝试右侧
            if (
              triggerRect.right + spacing + popoverRect.width <=
              viewportWidth
            ) {
              top = triggerRect.top;
              left = triggerRect.right + spacing;
              placement = "right";
            }
            // 判断是否可以放在下方
            else if (
              triggerRect.bottom + spacing + popoverRect.height <=
              viewportHeight
            ) {
              top = triggerRect.bottom + spacing;
              left = triggerRect.left;
              placement = "bottom";
            }
            // 否则尝试上方
            else if (triggerRect.top - spacing - popoverRect.height >= 0) {
              top = triggerRect.top - spacing - popoverRect.height;
              left = triggerRect.left;
              placement = "top";
            }

            // 最后尝试左侧
            else if (triggerRect.left - spacing - popoverRect.width >= 0) {
              top = triggerRect.top;
              left = triggerRect.left - spacing - popoverRect.width;
              placement = "left";
            } else {
              // 实在放不下，默认底部强制放置
              top = Math.min(
                triggerRect.bottom + spacing,
                viewportHeight - popoverRect.height
              );
              left = Math.min(
                triggerRect.left,
                viewportWidth - popoverRect.width
              );
              placement = "force-bottom";
            }
          } else {
            // iOS 兼容：使用点击坐标定位
            const clickX = this.event.clientX || 0;
            const clickY = this.event.clientY || 0;
            
            // 默认尝试在点击位置下方打开
            left = clickX - (popoverRect.width / 2); // 水平居中对齐点击位置
            top = clickY + spacing; // 下方打开
            
            // 确保不超出右侧边界
            if (left + popoverRect.width > viewportWidth - spacing) {
              left = viewportWidth - popoverRect.width - spacing;
            }
            
            // 确保不超出左侧边界
            if (left < spacing) {
              left = spacing;
            }
            
            // 如果下方放不下，尝试上方打开
            if (top + popoverRect.height > viewportHeight - spacing) {
              top = clickY - popoverRect.height - spacing;
              
              // 如果上方也放不下，放在可视区域内
              if (top < spacing) {
                top = Math.max((viewportHeight - popoverRect.height) / 2, spacing);
              }
            }
            
            // 确保不超出顶部边界
            if (top < spacing) {
              top = spacing;
            }
            
            // 确保不超出底部边界
            if (top + popoverRect.height > viewportHeight - spacing) {
              top = viewportHeight - popoverRect.height - spacing;
            }
          }
          
          // 设置样式：fixed 定位
          popoverEl.style.top = `${top}px`;
          popoverEl.style.left = `${left}px`;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./moreChatPopover.scss";
</style>
